export const getStyles = (_, { palette = {} }) => ({
  header: {
    '& .ms-ContextualMenu-header': {
      padding: '0px 4px',
      color: `${palette.neutralPrimary}`,
      fontSize: 14,
      fontWeight: 600,
      height: 32,
    },
  },
  textButton: {
    width: '100%',
    '&:hover': {
      backgroundColor: `${palette.neutralQuaternaryAlt} !important`,
      color: `${palette.neutralPrimary} !important`,
    },
    '&:focus': {
      color: `${palette.neutralPrimary} !important`,
    },
    '&.btn:focus': {
      outline: `1px solid ${palette.neutralPrimary}`,
      outlineOffset: -1,
    },
    '&.btn.focus:after, &.btn:focus:after, &.btn:active:focus': {
      border: 0,
    },
  },
  removeButton: {
    width: 'inherit',
  },
  textDiv: {
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    width: 'inherit',
  },
  textSpan: {
    margin: '0px 4px 0px 4px',
    display: 'inline-block',
    flexGrow: 1,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textAlign: 'left',
    width: 'inherit',
  },
  recentFilterText: {
    display: 'flex',
    maxWidth: 240,
    '& span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  savedFilterItem: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  recentFilterItem: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    '& .recent-filter-button': {
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
  savedFilterRemove: {
    display: 'inline-block',
    float: 'right',
    fontSize: 12,
    '& a span.iconba.iconba-Cancel': {
      margin: '0px 4px',
    },
  },
  savedFilterText: {
    color: palette.neutralPrimary,
    verticalAlign: 'middle',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '150px',
    width: 'inherit',
    float: 'left',
  },
  filterMenu: {
    '& .search-box': {
      padding: '2px 8px',
      height: '36px',
    },
  },
  filterRemoveModel: {
    zIndex: '1000001 !important', // ensure this one larger than contextual menu.
    '& .ms-Dialog-main': {
      maxWidth: 480,
      width: 480,
      '& .ms-Dialog-title': {
        paddingLeft: 24,
        paddingTop: 14,
        paddingBottom: 15,
      },
      '& .ms-Dialog-inner': {
        marginTop: 11,
        '& .ms-Dialog-actions': {
          marginTop: 18,
          '& .ms-Dialog-actionsRight': {
            textAlign: 'Left',
            '& .ms-Dialog-action': {
              marginLeft: 0,
            },
          },
        },
      },
      '& .ms-Button': {
        height: 12,
        width: 12,
        padding: 9,
        '& .ms-Button-icon': {
          height: 12,
          width: 12,
          fontSize: 12,
          margin: 0,
          top: 0,
        },
      },
    },
  },
  rootCallout: {
    zIndex: 1000000,
    minWidth: 180,
  },
  rootSubCallout: {
    minWidth: 'fit-content',
  },
});
